import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { Toast } from 'vant'
import { ComponentInstance } from 'vant/lib/utils'
import { setLoading } from './view-helper'
import { reportUrl } from './report-sentry'

const timeout = 30 * 1000

export interface ResultType<T> {
  data: T
  code: string
  msg: string
}

function createService(
  withCredentials = true,
  loading = false,
  toasting = false,
  options?: AxiosRequestConfig
) {
  let toast: ComponentInstance | null = null
  const instance = axios.create(
    options
      ? { timeout, withCredentials, ...options }
      : { timeout, withCredentials }
  )

  // 设置post默认请求头
  // 'Content-Type': 'application/x-www-form-urlencoded'
  // 'Content-Type': 'application/json;charset=UTF-8'
  instance.defaults.headers.post['Content-Type'] =
    'application/x-www-form-urlencoded'
  // 'application/json;charset=UTF-8'

  // 请求拦截器
  instance.interceptors.request.use(
    (config: AxiosRequestConfig) => {
      // const token = store.state.token
      // token && (config.headers.Authorization = token)

      if (loading) {
        setLoading(true)
      }
      if (toasting) {
        toast = Toast.loading({
          forbidClick: true,
          duration: 0
        })
      }
      return config
    },
    (error: AxiosError) => {
      return Promise.reject(error)
    }
  )

  // 响应拦截器
  instance.interceptors.response.use(
    (response: AxiosResponse) => {
      if (loading) {
        setLoading(false)
      }
      if (toasting && toast) {
        toast.clear()
        toast = null
      }
      if (response && response.config && response.config.url) {
        reportUrl(response)
      }

      const res: ResultType<any> =
        response && response.data ? response.data : response
      if (response.status === 200) {
        return Promise.resolve(res || {})
      } else {
        return Promise.reject(res || {})
      }
    },
    (error: AxiosError) => {
      if (loading) {
        setLoading(false)
      }
      if (toasting && toast) {
        toast.clear()
        toast = null
      }
      if (error.isAxiosError) {
        reportUrl(error.response, true)
      }

      const { response } = error
      if (!response) {
        // 处理断网的情况
        // eg:请求超时或断网时，更新state的network状态
        // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
        if (!window.navigator.onLine) {
          // store.commit('changeNetwork', false)
        } else {
          return Promise.reject(error)
        }
      }

      return Promise.reject(error)
    }
  )
  return instance
}

/* 不带cookie */
const $http = createService(false)
export const http = $http

/* 不带cookie、带loading */
const $httpWithLoading = createService(false, true, false)
export const httpWithLoading = $httpWithLoading

/* 不带cookie、带toast */
const $httpWithToast = createService(false, false, true)
export const httpWithToast = $httpWithToast

/* 带cookie */
const $httpWithCookie = createService(true)
export const httpWithCookie = $httpWithCookie

/* 带cookie、带loading */
const $httpWithCookieAndLoading = createService(true, true, false)
export const httpWithCookieAndLoading = $httpWithCookieAndLoading

/* 带cookie、带toast */
const $httpWithCookieAndToast = createService(true, false, true)
export const httpWithCookieAndToast = $httpWithCookieAndToast
